
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent :overlay="false"
      max-width="800px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{on}">
        <v-btn v-on="on" color="primary" v-if='can_operate'>
          <v-icon small left>mdi-bullseye</v-icon>
          Metas vendedores
        </v-btn>
      </template>

      <v-card style="border-radius:12px" v-if="dialog">
        <v-card-title primary-title>
          <div class="headline mb-0">Metas por vendedores</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref='goalsForm' lazy-validation v-if="!loading_goals">
            <v-alert v-if="!(seller_data.sellers && seller_data.sellers.length)" type="info" dense>Nenhum vendedor com meta para esta região/mês.</v-alert>
            <div v-for="(goal,idx) in (seller_data.sellers || [])" :key="(goal.u_id || goal.user_id)+'--'+idx">
              <v-row justify="center" align="center">
                <v-col cols='6'>
                  <v-row align="center">
                    <v-icon class='mr-2'>mdi-account</v-icon>
                    <div class='subheading'>{{goal.s_name}}</div>
                  </v-row>
                </v-col>
                <v-col cols='6'>
                  <v-text-field  suffix='%' min='0' v-model.number="goal.current_goal_percentage" prepend-icon="mdi-search" label="Meta geral do mês" class="mx-2" type='number'></v-text-field>
                </v-col>
              </v-row>
              <v-divider v-if="idx + 1 < (seller_data.sellers || []).length" :key="`divider-${idx}`"></v-divider>
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <div>
            <span class='subheading'>Total das porcentagens: </span>
            <span :class="['title', sum_percentage_acceptable? '' : 'error--text']">
              {{sum_percentage.toLocaleString('pt-BR')}}
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialog = false">Cancelar</v-btn>
          <v-btn color="success" :disabled="!sum_percentage_acceptable" @click="submitGoals()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'SetupSellerGoals',
  props: {
    report: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      loading_goals: false,
      seller_data: {
        id: null,
        sellers: null,
      }
    }
  },
  methods: {
    setupSellerData(){
      this.loading_goals = true
      let { seller_report_id, sellers } = this.report || {}
      let list = Array.isArray(sellers) ? sellers : []
      let mapped = list.map(s => {
        let pct = s.current_goal_percentage != null && s.current_goal_percentage !== ''
          ? Number(s.current_goal_percentage)
          : Number((Number(s.goal_percentage) * 100).toFixed(2))
        return {
          u_id: s.u_id ?? s.user_id,
          s_name: s.s_name ?? s.seller_name ?? '',
          current_goal_percentage: Number(Number(pct).toFixed(2)),
        }
      })
      this.seller_data = { ...this.seller_data, id: seller_report_id, sellers: [...mapped] }
      this.loading_goals = false
    },
    submitGoals(){
      if (this.$refs.goalsForm.validate()){
        let c = confirm('Deseja enviar metas?')
        if (c){
          this.saveSellerGoals()
        }
      }
    },
    saveSellerGoals(){
      let { id, sellers } = this.seller_data
      if (!id || !Array.isArray(sellers) || sellers.length === 0) return
      Api.SellerDailyReport.updateSellerGoals({ id, seller_goals: sellers }).then(r => r.data).then(() => {
        this.dialog = false
        this.$emit('done')
      }).catch((err) => {
        console.error('Erro ao salvar metas dos vendedores', err)
      })
    },
  },
  computed: {
    sum_percentage(){
      let sellers = this.seller_data.sellers || []
      let sum = sellers.reduce((acc, one)=> acc + Number(one.current_goal_percentage || 0), 0)
      sum = Math.round(sum*100)/100
      return sum
    },
    sum_percentage_acceptable(){
      let acceptable = false
      if (this.sum_percentage){
        let sum = this.sum_percentage
        acceptable = (99.99 <= sum && sum < 100.1)
      }
      return acceptable
    },
    can_operate(){
      if ( this.has_roles(['Director', 'Manager', 'SalesExecutive'])){
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
        this.setupSellerData()
      } else if (nv == false){
        this.seller_data = {
          id: null,
          sellers: null,
        }
      }
    }
  },
}
</script>